export const OUTLET_PAGE_LIST_PAGE_REQUEST = 'OUTLET_PAGE_LIST_PAGE_REQUEST';

export const OUTLET_PAGE_LIST_SET_PROFILE = 'OUTLET_PAGE_LIST_SET_PROFILE';

export const OUTLET_PAGE_LIST_SET_OUTLETS = 'OUTLET_PAGE_LIST_SET_OUTLETS';

export const OUTLET_PAGE_LIST_SET_OUTLET_DETAIL =
  'OUTLET_PAGE_LIST_SET_OUTLET_DETAIL';

export const OUTLET_PAGE_LIST_CLICK_OUTLET_ROW =
  'OUTLET_PAGE_LIST_CLICK_OUTLET_ROW';

export const OUTLET_PAGE_LIST_CLICK_CANCEL = 'OUTLET_PAGE_LIST_CLICK_CANCEL';

export const OUTLET_PAGE_LIST_SEARCH = 'OUTLET_PAGE_LIST_SEARCH';

export const OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET =
  'OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET';

export const OUTLET_PAGE_LIST_CLICK_ADD_OUTLET =
  'OUTLET_PAGE_LIST_CLICK_ADD_OUTLET';

export const OUTLET_PAGE_LIST_SET_OUTLET_SLOTS =
  'OUTLET_PAGE_LIST_SET_OUTLET_SLOTS';

export const OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS =
  'OUTLET_PAGE_LIST_SET_USED_OUTLET_SLOTS';

export const OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE =
  'OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE';

export const OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE =
  'OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE';

export const OUTLET_PAGE_SHOW_CLONE_OUTLET = 'OUTLET_PAGE_SHOW_CLONE_OUTLET';

export const OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET =
  'OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET';

export const OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET =
  'OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET';

export const OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET =
  'OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET';

export const OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET =
  'OUTLET_PAGE_LIST_SET_REACTIVATED_OUTLET';

export const OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL =
  'OUTLET_PAGE_LIST_SHOW_CONFIRM_REACTIVATE_OUTLET_MODAL';

export const OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL =
  'OUTLET_PAGE_LIST_HIDE_CONFIRM_REACTIVATE_OUTLET_MODAL';

export const OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN =
  'OUTLET_PAGE_LIST_OPEN_RIGHT_COLUMN';

export const OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN =
  'OUTLET_PAGE_LIST_CLOSE_RIGHT_COLUMN';

export const OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL =
  'OUTLET_PAGE_LIST_SHOW_ADD_OUTLET_MODAL';

export const OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL =
  'OUTLET_PAGE_LIST_HIDE_ADD_OUTLET_MODAL';

export const OUTLET_PAGE_LIST_GET_OUTLET_PRICE =
  'OUTLET_PAGE_LIST_GET_OUTLET_PRICE';

export const OUTLET_PAGE_LIST_SET_OUTLET_PRICE =
  'OUTLET_PAGE_LIST_SET_OUTLET_PRICE';

export const OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS =
  'OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS';

export const OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS =
  'OUTLET_PAGE_LIST_SET_SUBSCRIPTION_STATUS';

export const OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA =
  'OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA';

export const OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON =
  'OUTLET_PAGE_LIST_DISABLE_PAY_BUTTON';

export const OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON =
  'OUTLET_PAGE_LIST_ENABLE_PAY_BUTTON';

export const OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE =
  'OUTLET_PAGE_LIST_SET_PAY_BUTTON_MESSAGE';

export const OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL =
  'OUTLET_PAGE_LIST_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';

export const OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL =
  'OUTLET_PAGE_LIST_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';

export const OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE =
  'OUTLET_PAGE_LIST_SET_PENDING_PAYMENT_MESSAGE';

export const OUTLET_PAGE_LIST_GET_BILLING = 'OUTLET_PAGE_LIST_GET_BILLING';

export const OUTLET_PAGE_LIST_SET_ON_LOADING =
  'OUTLET_PAGE_LIST_SET_ON_LOADING';

export const OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON =
  'OUTLET_PAGE_LIST_SET_DISABLE_SAVE_OUTLET_BUTTON';

export const OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY =
  'OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY';

export const OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY =
  'OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY';

export const OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY =
  'OUTLET_PAGE_SHOW_REACTIVATE_OUTLET_WITHOUT_PAY';

export const OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY =
  'OUTLET_PAGE_HIDE_REACTIVATE_OUTLET_WITHOUT_PAY';

export const OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL =
  'OUTLET_PAGE_SET_ON_LOADING_REACTIVATE_OUTLET_WITHOUT_PAY_MODAL';

export const OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL =
  'OUTLET_PAGE_SET_OPEN_PAYMENT_METHOD_MODAL';

export const OUTLET_PAGE_SET_PAYMENT_METHOD_LIST =
  'OUTLET_PAGE_SET_PAYMENT_METHOD_LIST';

export const OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS =
  'OUTLET_PAGE_SHOW_CLONE_OUTLET_PROGRESS';

export const OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS =
  'OUTLET_PAGE_HIDE_CLONE_OUTLET_PROGRESS';

export const OUTLET_PAGES_IS_STILL_CLONING = 'OUTLET_PAGES_IS_STILL_CLONING';

export const OUTLET_PAGES_UPDATE_CLONING_PROGRESS =
  'OUTLET_PAGES_UPDATE_CLONING_PROGRESS';

export const OUTLET_PAGES_CLONE_SUCCESS = 'OUTLET_PAGES_CLONE_SUCCESS';

export const OUTLET_PAGES_CLONE_SUCCESS_AND_CONFIRMED =
  'OUTLET_PAGES_CLONE_SUCCESS_AND_CONFIRMED';

export const OUTLET_PAGES_CLONE_FAILED = 'OUTLET_PAGES_CLONE_FAILED';

export const OUTLET_PAGES_CLONE_RESET = 'OUTLET_PAGES_CLONE_RESET';

export const OUTLET_PAGES_SUBMIT_CLONE_OUTLET =
  'OUTLET_PAGES_SUBMIT_CLONE_OUTLET';

export const OUTLET_PAGES_SHOW_CLONE_NOTIFICATION =
  'OUTLET_PAGES_SHOW_CLONE_NOTIFICATION';

export const OUTLET_PAGES_HIDE_CLONE_NOTIFICATION =
  'OUTLET_PAGES_HIDE_CLONE_NOTIFICATION';

export const OUTLET_PAGES_CHECK_CLONE_ON_PROGRESS =
  'OUTLET_PAGES_CHECK_CLONE_ON_PROGRESS';

export const OUTLET_PAGES_CHECK_CLONE_PROGRESS_CHANGED =
  'OUTLET_PAGES_CHECK_CLONE_PROGRESS_CHANGED';

export const OUTLET_PAGES_DELETE_CLONE_CACHE_ON_SUCCESS =
  'OUTLET_PAGES_DELETE_CLONE_CACHE_ON_SUCCESS';

export const OUTLET_PAGES_RESET_CLONING_PROGRESS =
  'OUTLET_PAGES_RESET_CLONING_PROGRESS';

export const OUTLET_PAGES_POPULATE_CLONE_OUTLET_DATA =
  'OUTLET_PAGES_POPULATE_CLONE_OUTLET_DATA';

export const OUTLET_PAGES_SET_CLONE_OUTLET_DATA =
  'OUTLET_PAGES_SET_CLONE_OUTLET_DATA';

export const OUTLET_PAGES_SET_CLONE_ELIGIBLE =
  'OUTLET_PAGES_SET_CLONE_ELIGIBLE';

export const OUTLET_PAGES_SET_CLONE_FORBIDDEN =
  'OUTLET_PAGES_SET_CLONE_FORBIDDEN';

export const OUTLET_PAGES_SET_CLONE_ID = 'OUTLET_PAGES_SET_CLONE_ID';

export const OUTLET_PAGES_REMOVE_CLONE_ID = 'OUTLET_PAGES_REMOVE_CLONE_ID';
